import './functions.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import { updateGroup } from '../../actions/group';
import Constants from '../../common/Constants';
import Navigation from '../Navigation/global';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  account: Member;
  group: Group;
  updateGroup: (group: Group) => void;
}

interface IState {
  props: 'props';
}

const FUNCTIONS = [
  { id: Constants.FUNCTION_MEMO, title: 'メモ' },
  { id: Constants.FUNCTION_WIKI, title: 'ウィキ' },
  { id: Constants.FUNCTION_NOTE, title: 'ノート' },
  { id: Constants.FUNCTION_BOARD, title: 'ボード' },
  { id: Constants.FUNCTION_MEMO_NOTIFICATION, title: 'メモ管理メール' }
];

class FunctionsComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      props: 'props'
    };
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (
      !this.props.account.isSystemAdmin &&
      !this.props.group.admins.includes(this.props.account.id)
    ) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.group.title + '/memos'
          }}
        />
      );
    }

    return (
      <div id="SettingsFunctions">
        <Navigation group={this.props.group.title} />

        <div id="SwitchAdminContainer">
          <SwitchAdmin isAdmin={true} group={this.props.group} />
        </div>

        <div id="Tabs">
          <Link to={'/' + this.props.group.title + '/settings/members'}>
            <div className="Tab">メンバー管理</div>
          </Link>
          <div className="Tab TabSelected">ファンクション</div>
          <Link to={'/' + this.props.group.title + '/settings/statistics'}>
            <div className="Tab">統計情報</div>
          </Link>
        </div>
        <div id="Content">
          {FUNCTIONS.map(FUNCTION => (
            <div className="Function" key={FUNCTION.id}>
              <input
                type="checkbox"
                checked={this.props.group.functions.includes(FUNCTION.id)}
                onChange={this.onChangeFunction.bind(this, FUNCTION.id)}
              />
              <span>{FUNCTION.title}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  onChangeFunction(functionId: number, e: any) {
    const group = Object.assign({}, this.props.group);
    if (group.functions.includes(functionId)) {
      group.functions = group.functions.filter(funcId => funcId !== functionId);
    } else {
      group.functions.push(functionId);
    }
    this.props.updateGroup(group);
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateGroup(group: Group) {
      dispatch(updateGroup(group));
    }
  };
};

const Members = connect(
  mapStateToProps,
  mapDispatchToProps
)(FunctionsComponent);

export default Members;



// WEBPACK FOOTER //
// ./src/components/Settings/functions.tsx